import { stateModels } from '@/models'

const makeProperties = <S>(values: stateModels.Values<S>) => {
	const keys = Object.keys(values)
	const result = {} as stateModels.StateProperties<S>

	for (let i = 0, { length } = keys; i < length; i++) {
		const key = keys[i] as keyof S
		result[key] = {
			value: values[key],
			writeable: true,
			enumerable: true,
			configurable: true,
		}
	}

	return result
}

export const useState = <S = object>(initialState = {} as S): stateModels.UseState<S> => {
	const state = initialState

	const setState: stateModels.SetState<S> = (values: stateModels.Values<S>, callback?: (s: S) => void) => {
		Object.defineProperties(state, makeProperties(values))
		if (callback) {
			callback(state)
		}
	}

	return {
		setState,
		state,
	}
}
